import { ClockIcon } from "@heroicons/react/24/solid";

const ButtonAddTimestamp = ({ onHandleClick }) => {
    return (
        <button
            onClick={onHandleClick}
            type="button"
            onMouseDown={(e) => e.preventDefault()} // keeps textarea focus + selection
            className="inline-flex items-center p-1 text-xs text-white bg-teal-500 border border-transparent rounded-sm shadow-sm hover:bg-teal-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-teal-500"
        >
            <span>Add Timestamp</span>
            <ClockIcon className="w-5 h-5 p-1" />
        </button>
    );
};
export default ButtonAddTimestamp;
